jQuery(document).ready(function ($) {

    $(document).on('click', '.js-submit', function () {

        const $this = $(this),
            form = $this.closest('form'),
            data = form.serializeArray(),
            newData = {},
            response = form.find('.response');

        window.notValid = [];

        response.removeClass('pwc--error').empty();
        form.find('.pwc-not-valid').removeClass('pwc-not-valid');

        $.each(data, function () {
            if (evaluateValue(this, form)) {
                newData[this.name] = this.value;
            }
        });

        if (Object.keys(newData).length === data.length && !$(this).attr('disabled')) {
            $.ajax({
                url: "/wp-json/downloads/mail/",
                method: 'POST',
                data: newData,
                beforeSend() {
                    $(this).attr('disabled', true);
                },
                success: function (response) {

                    switch (response.type) {
                        case 'email':
                            window.location.href = response.redirect
                            break;
                        case 'direct':
                            window.open(response.redirect);
                            break;
                    }
                }
            });
        } else {
            $.each(window.notValid, function () {
                $('[name="' + this + '"]').addClass('pwc-not-valid');
            });
            response.addClass('pwc--error').html('Niet alle velden zijn correct ingevuld').slideDown(300);
        }
        return false;
    });

    function evaluateValue(data, form) {
        const field = form.find('[name="' + data.name + '"]');
        if (field.prop('required')) {
            switch (field.prop('type')) {
                case 'email':
                    if (validateEmail(data.value)) {
                        return true;
                    } else {
                        window.notValid.push(data.name);
                    }
                    break;
                default:
                    if (data.value) {
                        return true;
                    } else {
                        window.notValid.push(data.name);
                    }
            }
        } else {
            return true;
        }
    }

    function validateEmail(val) {
        const email = /^.+@[^\.].*\.[a-z]{2,}$/g;
        return email.test(val);
    }

    function hasAttribute(attr) {
        return typeof attr !== 'undefined' && attr !== false;
    }

});